import styled from 'styled-components';
import { Card, FieldsContainer } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

export const FormWrapper = styled(FieldsContainer)`
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

export const HintTextBox = styled.p`
    text-align: center;
`;

export const PublicFormWrapper = styled(Card)`
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
    backface-visibility: hidden;

    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const NewPublicFormWrapper = styled(Stack)`
    width: 100%;
    max-width: 400px;
`;

export const LinkWrapper = styled.div`
    text-align: center;
    margin-top: 1em;
`;
